import { createSlice } from '@reduxjs/toolkit';

export const filter = createSlice({
  name: 'filter',
  initialState: {
    inStock: {
      active: false,
    },
    onSale: {
      active: false,
    },
    newProds: {
      active: false,
    },
    price: {},
    brand: {
      items: [],
    },
    filters: [],
    filterOrder: [],
    filterActivity: {},
    hasActive: false,
    amount: null,
  },

  reducers: {
    update: (state, { payload }) => {
      const {
        inStock,
        onSale,
        newProds,
        price,
        brand,
        filters,
        filterOrder,
        filterActivity,
        sortedValues,
        hasActive,
        amount,
      } = payload;
      state.inStock = JSON.parse(JSON.stringify(inStock));
      state.onSale = JSON.parse(JSON.stringify(onSale));
      state.newProds = JSON.parse(JSON.stringify(newProds));
      state.price = JSON.parse(JSON.stringify(price));
      state.brand = JSON.parse(JSON.stringify(brand));
      state.filters = JSON.parse(JSON.stringify(filters));
      state.filterOrder = JSON.parse(JSON.stringify(filterOrder));
      state.filterActivity = JSON.parse(JSON.stringify(filterActivity));
      state.sortedValues = JSON.parse(JSON.stringify(sortedValues));
      state.hasActive = hasActive;
      state.amount = amount;

      return state;
    },

    setPrice: (state, { payload }) => {
      const { from: newFrom, to: newTo } = payload;
      const { price } = state;
      const { from, to, min, max } = price;
      if (from === newFrom && to === newTo) {
        price.active = false;
        return state;
      }
      price.from = newFrom !== undefined ? parseFloat(newFrom, 10) : min;
      price.to = newTo !== undefined ? parseFloat(newTo, 10) : max;

      if (min === parseFloat(newFrom, 10) && max === parseFloat(newTo, 10)) {
        price.active = false;
      } else {
        price.active = true;
      }

      state.price = Object.assign({}, price);
      return state;
    },

    toggleInStock: (state) => {
      const { inStock } = state;
      const newActive = !inStock.active;
      inStock.active = newActive;
      state.inStock = Object.assign({}, inStock);

      return state;
    },

    toggleOnSale: (state) => {
      const { onSale } = state;
      const newActive = !onSale.active;
      onSale.active = newActive;
      state.onSale = Object.assign({}, onSale);

      return state;
    },

    toggleNewProds: (state) => {
      const { newProds } = state;
      const newActive = !newProds.active;
      newProds.active = newActive;
      state.newProds = Object.assign({}, newProds);

      return state;
    },

    toggleBrand: (state, { payload: slug }) => {
      const { brand } = state;
      const { items } = brand;
      const item = items.find((b) => b.slug === slug);
      if (item !== undefined) {
        const newActive = !item.active;
        item.active = newActive;
        state.brand = Object.assign({}, brand);
      }

      return state;
    },

    toggleFilter: (state, { payload }) => {
      const { filterSlug, slug } = payload;
      const { filters } = state;
      const filter = filters.find((f) => f.slug === filterSlug);
      if (filter === undefined) {
        return state;
      }

      const { items } = filter;
      const item = items.find((f) => f.slug === slug);
      if (item !== undefined) {
        const newActive = !item.active;
        item.active = newActive;
        state.filters = [...filters];
      }

      return state;
    },

    reset: (state) => {
      const { brand, filters } = state;

      brand.items.forEach((item) => (item.active = false));
      filters.forEach((f) => {
        f.items.forEach((item) => (item.active = false));
      });

      state.brand = Object.assign({}, brand);
      state.filters = [...filters];

      const { price } = state;
      const { min, max } = price;
      price.from = min;
      price.to = max;
      price.active = false;
      state.price = Object.assign({}, price);

      state.inStock.active = false;
      if (typeof state.onSale !== 'boolean') {
        state.onSale.active = false;
      }
      if (typeof state.newProds !== 'boolean') {
        state.newProds.active = false;
      }

      return state;
    },

    resetFilter: (state, { payload: slug }) => {
      if (slug === 'brand') {
        const { brand } = state;
        brand.items.forEach((item) => (item.active = false));
        state.brand = Object.assign({}, brand);
        return state;
      }

      if (slug === 'price') {
        const { price } = state;
        const { min, max } = price;

        price.from = min;
        price.to = max;
        price.active = false;
        state.price = Object.assign({}, price);
        return state;
      }

      if (slug === 'inStock') {
        state.inStock.active = false;
        return state;
      }

      if (slug === 'onSale') {
        state.onSale.active = false;
        return state;
      }

      if (slug === 'newProds') {
        state.newProds.active = false;
        return state;
      }

      const { filters } = state;
      const filter = filters.find((f) => f.slug === slug);
      if (filter === undefined) {
        return state;
      }
      filter.items.forEach((item) => (item.active = false));
      state.filters = [...filters];
      return state;
    },
  },
});

export default filter.reducer;
